/* angular:styles/component:css;7f84e2a827d98435eabb19d74c5a417fa77a9ae7913fd26e8f95c79dc40f1fcd;/Users/haniehnasirpour/Desktop/Projects/ostad-visit/ostad_website/src/app/components/navbars/auth-navbar/auth-navbar.component.ts */
@media (min-width: 640px) {
  .sm:hidden {
    display: none;
  }
}
/*# sourceMappingURL=auth-navbar.component.css.map */
